export const ANNUAL_STOCKTAKE_ACTIVITY_NAME = 'Inwentaryzacja roczna';
export const ANNUAL_STOCKTAKE_TAG_NAME = 'Inwentaryzacja Roczna';
